import BackendClient from './backendClient';
import { encoderEndpointV1 } from "../utils/config";

export const convertPDFToSlides = (accountId, body) => BackendClient.post(`${encoderEndpointV1}accounts/${accountId}/convert-to-asset-slides`, body, true);

export const confirmPDFToSlides = (accountId, jobId) => BackendClient.get(`${encoderEndpointV1}accounts/${accountId}/jobs/${jobId}?refresh=true`);
